/**
 * Adds accordion markup - written for Yoast blocks
 */
function accordion(qSelector, aSelector, qaSelector) {
	let qs = document.querySelectorAll(qSelector);
	if (!qs.length) return;
	let a, qa, id;

	// 	function collapse(qEl, aEl) {
	// 		qEl.setAttribute('aria-expanded', 'false');
	// 		aEl.setAttribute('hidden', '');
	// 	}
	//
	// 	function expand(qEl, aEl) {
	// 		qEl.setAttribute('aria-expanded', 'true');
	// 		aEl.removeAttribute('hidden');
	// 	}

	// set initial states
	for (let q of qs) {
		qa = q.closest(qaSelector);
		if (!qa) qa = q.parentElement;
		if (!qa) continue;
		a = qa.querySelector(aSelector);
		if (!a) a = q.nextSibling;
		if (!a) continue;
		id = a.id;
		if (!id) id = qa.id;
		if (!id) continue;
		q.setAttribute('role', 'button');
		q.setAttribute('aria-controls', id);
		q.setAttribute('aria-expanded', 'false');

		q.addEventListener('click', function () {
			let expanded = this.getAttribute('aria-expanded') === 'true';
			if (expanded) {
				this.setAttribute('aria-expanded', 'false');
			} else {
				this.setAttribute('aria-expanded', 'true');
			}
		});
	}

	// document.addEventListener('click', function (event) {
	// 	q = event.target.closest(qSelector);
	// 	if (!q) return;
	// 	let expanded = a.getAttribute('aria-expanded') === 'true';
	// 	a = qa.querySelector(aSelector);
	// 	a = a ? a : q.nextSibling;
	// 	if (!a) return;
	// 	if (expanded) {
	// 		collapse(q, a);
	// 		return;
	// 	}
	// 	expand(q, a);
	// });
}

accordion('.schema-faq-question', '.schema-faq-answer', '.schema-faq-section');
